module.exports = __webpack_public_path__ + "img/ic_dc.72d9591d.svg";